import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { useActionData } from 'react-router-dom';

const baseUrl = process.env.REACT_APP_BASE_API_URL;

export const sessionApi = createApi({
  reducerPath: 'sessionApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      // Get the user from the auth slice in the Redux store
      const user = getState().auth?.user;

      // If the user is logged in, add the token to the headers
      if (user?.token) {
        headers.set('authorization', `${user.token}`);
      }

      return headers;
    },
  }),
  endpoints: (builder) => ({
    // Login endpoint
    newSession: builder.mutation({ //just locks, no actual session id
      query: (body) => ({
        url: 'session/new',
        method: 'POST',
        body: body,
      }),
    }),
    setSession: builder.mutation({
      query: (body) => ({
        url: 'session',
        method: 'POST',
        body: { ...body, source: "mobile_app" },
        //   body: {
        //     "booth_id": 75,
        //     "user_id": 821,
        //     "lock_id": "0886b29b-6437-49b7-b8c4-e163ac29b925",
        //     "source": "mobile_app",
        //     "session_price": 1

        // }
      }),
    }),
    modifyComponents: builder.mutation({
      query: (body) => ({
        url: 'session_components/addSessionComponent',
        method: 'POST',
        body: body,
        // body: [
        //   {
        //     "session_id": 12987,
        //     "value": "12",
        //     "component_id": 1,
        //     "component_value_id": 12
        //   }
        // ]
      }),
    }),
    cancelSession: builder.mutation({
      query: (body) => ({
        url: 'session/unlock',
        method: 'post',
        body: { ...body, source: "app" },
      }),
    }),
    activateSession: builder.mutation({
      query: (body) => ({
        url: `session/activate/${body.sessionId}`,
        method: 'post',
        body: body,
        // body: {
        //   sessionId:,
        //   sid:
        // }
      }),
    }),
  }),
});

export const {
  useNewSessionMutation,
  useCancelSessionMutation,
  useSetSessionMutation,
  useModifyComponentsMutation,
  useActivateSessionMutation
} = sessionApi;
